enum ActionType {
    REQUEST_TREND = '[DASHBOARD/ETS_TREND] GET ETS TREND',
    RECEIVE_TREND = '[DASHBOARD/ETS_TREND] SET ETS TREND',
}

export default ActionType
